import { gql } from "graphql-tag"

const news = gql`
  type Query {
    draftsNews: [News]
    draftsNewsWave(cursor: String): NewsWave

    getNews(id: ID!): News
    getNewsList: [News]
    searchNews(searchNewsInput: SearchNewsInput!): [News]

    getOutletById(id: ID!): Outlet
    getOutlets(query: GetQueryOutlets): [Outlet!]!

    searchOutlets(searchOutletsInput: SearchOutletsInput!): [Outlet]
  }
`

export default news
